(<template>
  <el-menu id="always-on-top"
           background-color="#545c64"
           text-color="#fff"
           active-text-color="#7ce4ff"
           :router="true"
           :default-active="$route.path"
           mode="horizontal">
    <el-menu-item index="/">
      <img style="height: 90%;" src="../assets/tourinfo-logo.png">
    </el-menu-item>
    <div v-if="$session.exists()">
      <el-submenu v-if="$session.get('role') === 'admin'" align="left" index="/users" id="user-menu">
        <template slot="title">
          <i class="el-icon-fa-users"></i>
          <span v-translate>Users</span>
        </template>
        <el-menu-item index="/users/list" id="user-menu-list">
          <i class="el-icon-fa-list-ul"></i>
          <span v-translate>Tourinfo users list</span>
        </el-menu-item>
        <el-menu-item index="/users/create" id="user-menu-create">
          <i class="el-icon-fa-user-plus"></i>
          <span v-translate>Create user</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu align="left" index="/monuments">
        <template slot="title">
          <i class="el-icon-fa-globe"></i>
          <span v-translate>Monuments</span>
        </template>
        <el-menu-item index="/monuments/list">
          <i class="el-icon-fa-list-ul"></i>
          <span v-translate>Monuments list</span>
        </el-menu-item>
        <el-menu-item index="/monuments/create">
          <i class="el-icon-fa-plus-circle"></i>
          <span v-translate>Add monument</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu align="left" index="/walks">
        <template slot="title">
          <i class="el-icon-fa-compass"></i>
          <span v-translate>Themed walks</span>
        </template>
        <el-menu-item index="/walks/list">
          <i class="el-icon-fa-list-ul"></i>
          <span v-translate>Themed walks list</span>
        </el-menu-item>
        <el-menu-item index="/walks/create">
          <i class="el-icon-fa-plus-circle"></i>
          <span v-translate>Add new themed walk</span>
        </el-menu-item>
      </el-submenu>
       <el-submenu align="left" index="/souvenirs">
        <template slot="title">
          <i class="el-icon-fa-gift"></i>
          <span v-translate>Souvenirs</span>
        </template>
        <el-menu-item index="/souvenirs/list">
          <i class="el-icon-fa-list-ul"></i>
          <span v-translate>Souvenirs list</span>
        </el-menu-item>
        <el-menu-item index="/souvenirs/create">
          <i class="el-icon-fa-plus-circle"></i>
          <span v-translate>Add new souvenir</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu align="left" index="/companies">
        <template slot="title">
          <i class="el-icon-fa-cutlery"></i>
          <span v-translate>Partner companies</span>
        </template>
        <el-menu-item index="/companies/list">
          <i class="el-icon-fa-list-ul"></i>
          <span v-translate>Partner companies list</span>
        </el-menu-item>
        <el-menu-item index="/companies/create">
          <i class="el-icon-fa-plus-circle"></i>
          <span v-translate>Add a new partner company</span>
        </el-menu-item>
      </el-submenu>
      <el-menu-item index="/about">
        <i class="el-icon-info"></i>
        <span v-translate>About Us</span>
      </el-menu-item>
      <el-submenu align="left" index="4" class="menu-item-right" id="logout-menu">
        <template slot="title">
          <img id="navbar-profile-image" :src="avatarUrl"/>
          {{$session.get('username')}}
        </template>
        <el-menu-item index="/profile">
          <i class="el-icon-fa-pencil"></i>
          <span v-translate>Edit profile</span>
        </el-menu-item>
        <el-menu-item index="/signout" id="logout-menu-button">
          <i class="el-icon-fa-sign-out"></i>
          <span v-translate>Sign out</span>
        </el-menu-item>
      </el-submenu>
    </div>
    <div v-else>
      <el-menu-item id="about-us" index="/about">
        <i class="el-icon-info"></i>
        <span v-translate>About Us</span>
      </el-menu-item>
      <el-menu-item index="/signin" class="menu-item-right" id="login-menu-button">
        <i class="el-icon-fa-sign-in"></i>
        <span v-translate>Sign in</span>
      </el-menu-item>
    </div>
  </el-menu>
</template>)

(<script>
import md5 from 'md5'

export default {
  name: 'tourguide-navbar',
  computed: {
    avatarUrl () {
      return `https://www.gravatar.com/avatar/${md5(this.$session.get('email').trim().toLowerCase())}`
    }
  }
}
</script>)

(<style>
#always-on-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.menu-item-right {
  position: absolute !important;
  right: 0 !important;
  width: 11em !important;
}

#navbar-profile-image {
  height: 80%;
  padding: 5%;
  border-radius: 50%;
}
</style>)



// WEBPACK FOOTER //
// src/components/Tourguide-Navbar.vue